var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creative-dashboard"},[_c('TutorialArrow'),_c('Dashboard'),_c('VueNotification',{attrs:{"group":"notifications-wrapper","position":"bottom right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }